import ProgramSession from './ProgramSession';
import Section from './Section';

class Program {
  id?: string | null = null;
  deactivatable? = true;
  standalone? = false;
  enabled = true;
  ends_at: Date | null = null;
  lower_age_in_months: number | null = null;
  name: string | null = null;
  program_sessions?: ProgramSession[] = [];
  program_sessions_attributes: any;
  ratio_numerator: number | null = null;
  registration_capacity: number | null = null;
  sections?: Section[] = [];
  starts_at: Date | null = null;
  upper_age_in_months: number | null = null;
}

export default Program;
